import angular from 'angular';

// Component
import component from './dashboardScreen.component';

// Load all services
import '../../../lib/service';
import themeSwitcherServiceModule from '../../../lib/service/ThemeSwitcherService';
import positionDisplayBoxComponent from './components/positionDisplayBox';
import invitationPositionDisplayBoxComponent from './components/invitationPositionDisplayBox';
import adhocModal from './components/adhocModal';
import filesModal from './components/filesModal';
import addPhotosModal from './components/addPhotosModal';
import guerrillaModal from './components/guerrillaModal';
import editPositionModal from './components/editPositionModal';
import calendarComponent from './components/calendar';
import calendarWrapperComponent from './components/calendarWrapper';
import claimDisplayBox from './components/claimDisplayBox';
import positionsPanelsModule from './components/positionsPanels';
import positionSearchModalModule from './components/positionSearchModal';
import networkSettingsModalModule from './components/networkSettingsModal';
import positionSearchServiceModule from '../../../lib/service/PositionSearchService';
import opportunitiesPanelsModule from './components/opportunitiesPanels';
import dashboardNotificationsModule from './components/dashboardNotifications';
import changePasswordModalModule from '../../../lib/components/modals/changePasswordModal';
import 'ngclipboard/src/ngclipboard.js';

// Dependencies
import translation from '../../../lib/translation';

const moduleName = 'staff.dashboardScreen';
let module = angular.module(moduleName, [
  'recaps.services',
  'ngclipboard',
  translation,
  positionDisplayBoxComponent.name,
  invitationPositionDisplayBoxComponent.name,
  calendarComponent.name,
  calendarWrapperComponent.name,
  adhocModal.name,
  filesModal.name,
  addPhotosModal.name,
  guerrillaModal.name,
  editPositionModal.name,
  guerrillaModal.name,
  claimDisplayBox.name,
  themeSwitcherServiceModule.name,
  positionsPanelsModule.name,
  positionSearchModalModule.name,
  networkSettingsModalModule.name,
  positionSearchServiceModule.name,
  opportunitiesPanelsModule.name,
  dashboardNotificationsModule.name,
  changePasswordModalModule.name,
]);

module.component('dashboardScreen', component);

export default module;
